import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import clsx from "clsx";
import { useFormikContext } from "formik";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../../Typography/Title";
import DateSpan from "../date-span/DateSpan";
import useAvailableQuantityUnits from "../../utils/useAvailableOperationUnits";
import DetailSection from "../DetailSection";
import QuantityInput from "../../../action-inputs/quantity/QuantityInput";
import ActionModalDescriptionSection from "../description/ActionModalDescriptionSection";
import WateringLimits from "./WateringLimits";
import WateringDurationInput from "components/action-inputs/watering-duration/WateringDurationInput";

const WateringQuantityRow = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",
  flexWrap: "wrap",
});

const WateringLimitsSlot = styled("div")({
  flex: "1 1 240px",
  minWidth: "220px",
  maxWidth: "300px",
});

const WateringPerformed = ({
  viewMode,
  isFullWidth,
  operationTypeId,
  className,
  isNewVersion,
}) => {
  const { t } = useTranslation();
  const status = ACTION_STATUS.performed;
  const { values } = useFormikContext();

  const { availableQuantityUnits } = useAvailableQuantityUnits(
    values.taskId,
    operationTypeId,
  );
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  return (
    <div className={clsx("action-modal-card", "action-details-box", className)}>
      <div className={clsx({ "details-half-width": isFullWidth })}>
        <Title title={t("ActionModal.Details.Performed")} />
        {!isNewVersion && <DateSpan viewMode={viewMode} status={status} />}
        {Boolean(operationTypeId) && (
          <DetailSection
            title={t("ActionModal.Duration")}
            isRequired={!isViewMode}
            isNewVersion={isNewVersion}
          >
            <WateringDurationInput isViewMode={isViewMode} />
          </DetailSection>
        )}
        <DetailSection
          title={t("ActionModal.WaterQuantity")}
          isRequired={!isViewMode}
          isNewVersion={isNewVersion}
        >
          <WateringQuantityRow>
            <QuantityInput
              task="watering"
              isViewMode={isViewMode}
              quantityOptions={availableQuantityUnits}
            />
            <WateringLimitsSlot>
              <WateringLimits />
            </WateringLimitsSlot>
          </WateringQuantityRow>
        </DetailSection>
        <ActionModalDescriptionSection
          task="watering"
          isViewMode={isViewMode}
          isNewVersion={isNewVersion}
        />
      </div>
    </div>
  );
};

export default WateringPerformed;
